export default [
  {
    header: 'Express SMS',
  },
  {
    title: 'Compose',
    route: 'express',
    icon: 'ZapIcon',
  },
]
